import React, { useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { useDispatch, useSelector } from 'react-redux';
import TextInputField from './TextInputField';
import { getProductParameterFormData, getSelectedProductType } from '../../Reducers/App/Selectors';
import { loadProductParameterForm } from '../../Reducers/App/Actions';

interface NozzleOptionProps {
  zoneNumber: number;
}

const WaterTemperatureInput: React.FC<NozzleOptionProps> = (props) => {
  const { zoneNumber } = props;
  const dispatch = useDispatch();

  const productIdentifier = useSelector(getSelectedProductType)?.identifier;
  useEffect(() => {
    productIdentifier && dispatch(loadProductParameterForm());
  }, [productIdentifier, dispatch]);

  const formData = useSelector(getProductParameterFormData);
  const baseField = formData?.formFields.find(
    (field) => field.identifier === `cooling_zone_1_available_cooling_water_temperature`
  );
  if (!baseField) {
    return null;
  }
  const zoneField = {
    ...baseField,
    identifier: baseField.identifier.replace('1', zoneNumber.toString()),
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={4} container direction="column" style={{ marginTop: '8px' }}>
        <Typography>
          {t('coolingZone.zone')} {zoneNumber}
        </Typography>
      </Grid>
      <Grid item xs={8} container direction="column" alignItems="flex-end">
        <TextInputField field={zoneField} />
      </Grid>
    </Grid>
  );
};

export default WaterTemperatureInput;
